import DynamicPage from "./[...slugs]";

export default DynamicPage;
